'use client'

import { MobilePageTemplate } from '@/components/templates'
import { AuthTerms } from '@/features'
import { AuthPasskeyForm } from '@/features/Auth/ui/AuthPasskeyForm/AuthPasskeyForm'
import { AuthTotpForm } from '@/features/Auth/ui/AuthTotpForm/AuthTotpForm'
import { AuthWalletConfirmed } from '@/features/Auth/ui/AuthWalletConfirmed/AuthWalletConfirmed'
import { AuthWalletConnect } from '@/features/Auth/ui/AuthWalletConnect/AuthWalletConnect'
import { AuthWalletConnected } from '@/features/Auth/ui/AuthWalletConnected/AuthWalletConnected'
import { AuthWallets } from '@/features/Auth/ui/AuthWallets/AuthWallets'
import { AuthStep } from '@/features/Auth/auth.types'
import { getUser } from '@/features/Auth/auth.hooks'
import { useAppWallet } from '@/shared/wallet/useAppWallet'
import { useAuthStore } from '@/store'
import { useSearchParams } from 'next/navigation'
import React, { useCallback, useEffect, useState } from 'react'
import { useLocalStorage } from 'usehooks-ts'
import { getStorageKey } from '@/shared/helpers/localStorage'

export default function SignInPage() {
  const params = useSearchParams()
  const stepParam = params.get('step')
  const [selectedWallet, setSelectedWallet] = useState('')
  const [acceptedRules, _] = useLocalStorage(getStorageKey('godefi:auth:rules'), false)

  const [authStep, setAuthStep] = useState<AuthStep>(() => {
    if (stepParam) return Number(stepParam) as AuthStep
    return acceptedRules ? AuthStep.WALLETS : AuthStep.TERMS
  })

  const selectedWalletType = useAuthStore((state) => state.selectedWalletType)
  const clearAuthState = useAuthStore((state) => state.clear)
  const wallet = useAppWallet(selectedWalletType)

  useEffect(() => {
    if (!stepParam && !getUser()) {
      clearAuthState()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleBack = useCallback(async () => {
    if (authStep === AuthStep.WALLET_CONNECT || authStep === AuthStep.WALLET_CONNECTED) {
      if (wallet.connected) await wallet.disconnect()
      clearAuthState()
      setAuthStep(AuthStep.WALLETS)
      return
    }

    if (authStep === AuthStep.TOTP || authStep === AuthStep.PASSKEY) {
      setAuthStep(AuthStep.WALLET_CONNECTED)
    }
  }, [authStep, clearAuthState, wallet])

  return (
    <MobilePageTemplate withTabs={false}>
      <section>
        {(authStep === AuthStep.TERMS && !acceptedRules) && <AuthTerms setStep={setAuthStep} />}
        {authStep === AuthStep.WALLETS && <AuthWallets setStep={setAuthStep} setSelectedWallet={setSelectedWallet} />}
        {authStep === AuthStep.WALLET_CONNECT && selectedWallet && <AuthWalletConnect setStep={setAuthStep} selectedWallet={selectedWallet} onBack={handleBack} />}
        {authStep === AuthStep.WALLET_CONNECTED && <AuthWalletConnected setStep={setAuthStep} onBack={handleBack} />}
        {authStep === AuthStep.WALLET_CONFIRMED && <AuthWalletConfirmed />}
        {authStep === AuthStep.TOTP && <AuthTotpForm setStep={setAuthStep} onBack={handleBack} />}
        {authStep === AuthStep.PASSKEY && <AuthPasskeyForm onBack={handleBack} />}
      </section>
    </MobilePageTemplate>
  )
}
